import React, { useMemo, useEffect, Suspense, useState, useRef } from 'react'
import classes from "./DevicesList.module.css";
import ListCard from './ListCard';
import BasicTable from '../Table/Table/Table';
import { Await, Link, useLoaderData, useNavigate } from 'react-router-dom';
import { Oval } from 'react-loading-icons';
import UseDateFormat from '../hooks/UseDateFormat';
import Pill_Widget from '../UI/Widgets/Pill_Widget';
import DropdownList from '../UI/Cards/DropdownList';
import SettingsCog from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/settings.png"
import { useDispatch, useSelector } from 'react-redux';
import { addSitesToGroup, changeCamectIntegration, changeRole, clearDeviceLogs, copyIPIOSettings, copyUsersToAnotherDevice, getDevices, getGroups, getRandomUIPIOID, rebootIPIODevice, removeUser, resetIPIODevice, setSiteActive, suspendDevice, suspendUser } from '../../Api Methods/Api';
import { serviceActions } from '../../store/service-Slice';
import useSetCookie from '../hooks/UseSetCookie';
import Modal from '../Modal/Modal';
import DropDownForm from '../forms/DropDownForm';
import DropdownCustom from '../../components/forms/DropdownCreateGroup'
import DataManager from '../../hooks/DataManager';
import GridPaginationControls from '../Table/Table/GridPaginationControls';
import OutputPinCircle from '../UI/DataLayouts/OutputPinCircle';
import InputPinCircle from '../UI/DataLayouts/InputPinCircle';
import useParseArrayDeviceData from '../hooks/useParseArrayDeviceData';
import SetTag from '../Modal/ModalLayouts/SetTag';
import Button1 from '../UI/Button/Button1';
import CopyUsersPowersearch from '../../components/hooks/PowerSearchCopySettings'
import check from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import loading from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/loading.png'
import fail from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cross.png'
import gateway_icon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gatewayLogoPortal.png'
import ajax_icon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ajaxLogoPortal.png'
import hik_icon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/hikLogoPortal.png'
import aibox_icon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/aiBoxLogoPortal.png'
import dahua_icon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/dahuaLogoPortal.png'
import SetNameForUsers from '../Modal/ModalLayouts/SetName';
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import SuspendIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/suspend.png'
import ClearLogsIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/clearLogs.png'
import ChangePortalNameIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/changeTag.png'
import ChangeSerialIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/serial.png'
import CamectIntegrationIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/camectIntegration.png'
import CopyConfigIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/copyConfig.png'
import RebootIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/reboot.png'
import ResetIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/reset.png'
import AddToGroupIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/addToGroup.png'
import revokeAccess from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/revoke.png'
import ChangeRole from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/swap.png'
import { da, se } from 'date-fns/locale';
import { add } from 'date-fns';
import Input from '../CustomDropDown/Input/Input';
import SearchBar from '../PowerSearch/SearchBar';
import SetPortalName from '../Modal/ModalLayouts/SetPortalName';
import ChangeGroup from '../Modal/ModalLayouts/ChangeGroup';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import CreateHolidayMode from '../UI/Cards/Automations/HolidayMode/CreateHolidayMode';
import { SelectButton } from 'primereact/selectbutton';
import InviteExistingUserForm from '../forms/InviteExistingUserForm';
import MassAddUserForm from '../forms/MassAddUserForm';
import { Dialog } from 'primereact/dialog';
import SetSerial from '../Modal/ModalLayouts/SetSerial';
import { InputSwitch } from 'primereact/inputswitch';
import Pill_Widget_2 from '../UI/Widgets/Pill_Widget_2';
import Lottie from 'lottie-react';

const DevicesList = ({ devices, filtering, HandleSaveSearchQuery, totalPages, setTotalPages, pageFetchedIndex, setPageFetchedIndex, pageSize, setPageSize, totalDevices, setTotalDevices, isUsersSites, groupMode, update, setUpdate, hideControls, offlineOnly, isSortable, editUserAccess, sitesToRemove, setSitesToRemove, HandleGiveAccess, sitesForGroup, setSitesForGroup, sitesForGroupMode, setSitesForGroupMode, selectAllCancelled, showMassSelect, showMassSettings, setShowMassSettings, liveViewOnly }) => {

  const [SiteDevices, setSiteDevices] = useState(devices)
  console.log(devices)

  const token = useSelector(state => state.auth.token);
  const client = useSelector(state => state.auth.client);
  const company = useSelector(state => state.auth.companyName);
  const dataManager = new DataManager();
  const parsedData = useParseArrayDeviceData(devices);
  console.log(parsedData)
  const [suggestions, setSuggestions] = useState([]);
  const [selectionMade, setSelectionMade] = useState(false);
  const [siteID, setSiteID] = useState();
  const [copyUsersChecked, setCopyUsersChecked] = useState(dataManager.getItem('copyUsersChecked'));
  const [autoChooseASiteChecked, setAutoChooseASiteChecked] = useState(dataManager.getItem('autoChooseASite'));
  const [deviceKey, setDeviceKey] = useState("");
  const [queryDeviceList, setQueryDeviceList] = useState("");
  const [myUserID, setMyUserID] = useState("");
  const [nameSet, setNameSet] = useState('');
  const [deviceType, setDeviceType] = useState("");
  const [redraw, setRedraw] = useState(0)
  let newSiteUUID = "";
  const [selectedGroup, setSelectedGroup] = useState(null)
  const addAccessMode = dataManager.getItem('isAddAccessMode')
  const [checkedItems, setCheckedItems] = useState(dataManager.selectedSites.value || []);
  const loggedInAs = useSelector(state => state.auth.companyName);
  const userID = useSelector(state => state.auth.userID);
  const DeviceKey = localStorage.getItem("DeviceKey")
  const [openDropdownRowId, setOpenDropdownRowId] = useState(null);
  const [groups, setGroups] = useState([]);
  const apiData = { token, client }
  const dropdownRef = useRef(null);
  const ModalDialog = useRef();
  const [modalTitle, setModalTitle] = useState("title")
  const [modalComponent, setModalComponent] = useState()
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const columnVisibility = JSON.parse(localStorage.getItem('columnVisibility')) || {};
  const [selectAll, setSelectAll] = useState(null)
  const [portalName, setPortalName] = useState("")
  const [setNewPortalName, setSetNewPortalName] = useState(false)
  const [checkedSites, setCheckedSites] = useState([])
  const [selectAllSites, setSelectAllSites] = useState(false)
  const [selectedMassAction, setSelectedMassAction] = useState("")
  const [holidayModeType, setHolidayModeType] = useState("")
  const [success, setSuccess] = useState(false)
  const [failure, setFail] = useState(false)
  const [message, setMessage] = useState("")
  const [modalMessageSuccess, setModalMessageSuccess] = useState("")
  const [modalMessageFail, setModalMessageFail] = useState("")
  const [isCompleteModalOpen, setIsCompleteModalOpen] = useState(false);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);

  const [addToGroupVisible, setAddToGroupVisible] = useState(false)
  const [isMassAction, setIsMassAction] = useState(false)
  const [UUID, setUUID] = useState("")
  const [successVisible, setSuccessVisible] = useState(false)
  const [failVisible, setFailVisible] = useState(false)

  const GetGroups = async () => {
    try {
      const listOptions = await getGroups(apiData, dispatch);
      console.log(listOptions);
      setGroups(listOptions || []);
    } catch (error) {
      console.error('Failed to fetch groups:', error);
      setGroups([]);
    }
  };

  useEffect(() => {
    console.log(groupMode)
    GetGroups();
  }, []);

  const HandleNextPage = () => {
    setPageFetchedIndex(prevPageFetchedIndex => prevPageFetchedIndex + 1)
    dataManager.setItem('pageIndex', prevPageFetchedIndex => prevPageFetchedIndex + 1)
  }

  const HandlePreviousPage = () => {
    setPageFetchedIndex(prevPageFetchedIndex => prevPageFetchedIndex - 1)
    dataManager.setItem('pageIndex', prevPageFetchedIndex => prevPageFetchedIndex - 1)
  }

  const HandleSetPageIndex = (pageFetchedIndex) => {
    setPageFetchedIndex(pageFetchedIndex)
  }

  const HandlePageSize = (PageSize) => {
    console.log(PageSize)
    setPageSize(PageSize);
    dataManager.setItem('pageSize', PageSize)
    HandlePageCount(totalPages);
    dataManager.setItem('totalPages', totalPages)
  }

  const HandlePageCount = (totalPages) => {
    setTotalPages(totalPages);
  }

  useEffect(() => {

    if (selectAll == null) {
      return
    }

    if (selectAll) {
      if (addAccessMode) {
        console.log("here")
        const devices = SiteDevices.map(device => ({
          deviceID: device.id,
          name: device.tag !== '' ? device.tag : device.key
        }));

        setCheckedItems(devices)
      } else if (groupMode && !sitesForGroupMode) {
        console.log("here")
        const deviceUUIDs = SiteDevices.map(device => device.uuid);
        console.log(deviceUUIDs)

        setCheckedItems(deviceUUIDs);
      } else if (isUsersSites && !sitesForGroupMode) {
        console.log("here")
        const devices = SiteDevices.map(device => ({
          deviceUUID: device.uuid,
          deviceID: device.deviceID,
        }));

        setSitesToRemove(devices);
      } else if (sitesForGroupMode) {
        const deviceUUIDs = SiteDevices.map(device => device.uuid);
        console.log(deviceUUIDs)
        setSitesForGroup(deviceUUIDs);
      }
    }
    else {
      if (addAccessMode || groupMode) {
        setCheckedItems([]);
      } else if (isUsersSites && !sitesForGroupMode) {
        setSitesToRemove([]);
      } else if (sitesForGroupMode) {
        setSitesForGroup([])
      }
    }
  }, [selectAll, SiteDevices]);


  useEffect(() => {
    console.log(sitesToRemove)
  }, [sitesToRemove])

  useEffect(() => {
    console.log(checkedItems)
  }, [checkedItems])

  useEffect(() => {
    console.log(sitesForGroup)
  }, [sitesForGroup])

  useEffect(() => {

    console.log("here")

    if (dataManager.getItem('isAddAccessMode')) {
      console.log("here")
      const existingSites = dataManager.getItem('existingSites') || [];
      console.log(existingSites)
      const existingUUIDs = new Set(existingSites.map(site => site.uuid));
      const filteredDevices = devices.filter(device => !existingUUIDs.has(device.uuid));
      console.log(filteredDevices)
      setSiteDevices(filteredDevices);
      console.log((totalDevices))
    } else {
      console.log("here")
      setSiteDevices(devices);
    }
    dataManager.setItem('pageIndex', pageFetchedIndex)
  }, [pageFetchedIndex, pageSize, devices])

  const HandleChangeOwner = async (result) => {
    const data = await devices;
    const updatedData = data.map(row => {
      if (row.uuid === result.DeviceUUID) {
        return { ...row, name: result.dropDown };
      }
      return row;
    });

    setSiteDevices(updatedData);
  };

  const handleSettingsClick = (rowId) => {
    // If the clicked dropdown is already open, close it
    if (openDropdownRowId === rowId) {
      setOpenDropdownRowId(null);
    } else {
      // Otherwise, open the clicked dropdown
      setOpenDropdownRowId(rowId);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // Clicked outside the dropdown menu, so close it
        setOpenDropdownRowId(null);
      }
    };

    // Add event listener to listen for clicks outside the dropdown menu
    document.addEventListener('click', handleClickOutside);

    return () => {
      // Cleanup: Remove event listener when component unmounts
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const HandleShowModal = () => {
    ModalDialog.current.open();
  }

  const HandleCloseModal = () => {
    ModalDialog.current.close();
    setSuggestions([])
    setQueryDeviceList("")
    setSelectionMade(false)
    setSiteID("")
    setCopyUsersChecked(false)
    dataManager.setItem('copyUsersChecked', false);
    dataManager.setItem('setNameCopyUsers', "")
    setSelectedMassAction("")
  }

  useEffect(() => {
    if ((suggestions.length > 0) || ((redraw > 0) && queryDeviceList !== "")) {
      showCopySiteSettingsModal(deviceKey);
    }
  }, [suggestions, redraw])

  useEffect(() => {
    if (queryDeviceList !== "" && queryDeviceList !== " " && queryDeviceList !== null) {
      showCopySiteSettingsModal(deviceKey);
    } else {
      setSuggestions([])
    }
    //This is to rerender the modal and show the new data in the query
  }, [queryDeviceList])

  const HandleUipiodOnClick = (DeviceUUID) => {
    dispatch(serviceActions.setDeviceUUID(DeviceUUID));
    useSetCookie("DeviceUUID", DeviceUUID, 1);
    navigate("/Dashboard/SiteView/" + DeviceUUID);
  }

  const updateSiteID = (siteID) => {
    setQueryDeviceList(siteID);
    setSuggestions([]);
    dataManager.setItem('siteIDToCopyTo', siteID);
    setRedraw(redraw + 1)
    setSelectionMade(true);
  }

  const selectAnEmptySite = (event) => {
    setAutoChooseASiteChecked(event.target.checked);
    dataManager.setItem('autoChooseASite', event.target.checked);
    showCopySiteSettingsModal(deviceKey);
  }

  useEffect(() => {
    console.log(portalName)
  }, [portalName])

  const showCopySiteSettingsModal = (DeviceKey, type, deviceUUID) => {
    dataManager.setItem('setPortalGroup', "")
    dataManager.setItem('changePortalGroupForReset', "")
    setModalTitle("Copy configuration of: " + DeviceKey)
    setModalComponent(
      <div>
        {(<div>
          <label>
            <input
              type="checkbox"
              checked={dataManager.getItem('autoChooseASite')}
              onChange={selectAnEmptySite}
            />
            Automatic site selection
          </label>
          <br></br>
          {dataManager.getItem('autoChooseASite') &&
            <p style={{ color: "#4C4C4C" }}>The system will select a site ID with no users that is not named.</p>}
        </div>)}

        <br></br>

        {!dataManager.getItem('autoChooseASite') && (
          <div>
            <div>
              <CopyUsersPowersearch apiData={apiData} update={update} setUpdate={setUpdate} suggestions={suggestions} setSuggestions={setSuggestions} queryDeviceList={queryDeviceList} setQueryDeviceList={setQueryDeviceList} redraw={redraw} setRedraw={setRedraw} />
            </div>

            {suggestions.length > 0 && (
              <ul
                style={{
                  listStyle: 'none',
                  margin: 0,
                  padding: '0px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  position: 'absolute',
                  width: '94%',
                  backgroundColor: '#fff',
                  zIndex: 1000,
                }}
              >
                {suggestions.map((suggestion, index) => (
                  <li
                    key={index}
                    onClick={() => updateSiteID(suggestion)}
                    style={{
                      padding: '8px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #ddd',
                    }}
                  >
                    {suggestion}
                  </li>
                ))}
              </ul>
            )}

            <div
              style={{
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center"
              }}
            >
              <p style={{ color: "#4C4C4C" }}>{`Please note, only sites without a name or users will appear in search suggestions.`}</p>
              <p style={{ color: "#4C4C4C" }}>{`If a site isn't listed, you can still copy to it by entering its Site ID.`}</p>
            </div>
          </div>
        )}

        <br></br>

        <div>
          <label>
            <input
              type="checkbox"
              checked={dataManager.getItem('setPortalNameSelected')}
              onChange={handleSetPortalNameSelected}
            />
            Set portal name?
          </label>
          <br></br>
        </div>

        {dataManager.getItem('setPortalNameSelected') &&
          <SetPortalName
            placeholder={"Portal name"}
            HandleCloseModal={HandleCloseModal}
            setNameSet={setPortalName}
          />}

        <br></br>

        <div>
          <label>
            <input
              type="checkbox"
              checked={dataManager.getItem('setPortalGroupSelected')}
              onChange={handleSetGroupSelected}
            />
            Add to a group?
          </label>
          <br></br>
        </div>

        {dataManager.getItem('setPortalGroupSelected') && <div>
          <ChangeGroup
            apiData={apiData}
            DeviceUUID={""}
            companyName={""}
            NotificationTitle={""}
            label={"Please select a new group below"}
            dropDownOptions={groups
              .map(group => group.name)
              .sort((a, b) => a.localeCompare(b))
            }
            HandleCloseModal={HandleCloseModal}
            update={update}
            setUpdate={setUpdate}
            SiteDevices={SiteDevices}
            setSiteDevices={setSiteDevices}
          />
        </div>}

        <div>
          <br></br>
          <label>
            <input
              type="checkbox"
              checked={dataManager.getItem('copyUsersChecked')}
              onChange={handleCopyUsersSelected}
            />
            Copy users?
          </label>
          <br></br>
        </div>
        {dataManager.getItem('copyUsersChecked') && (
          <div>
            <SetNameForUsers
              placeholder={"Name of site for new users in app and in portal:"}
              HandleCloseModal={HandleCloseModal}
              setNameSet={setNameSet}
            />
            <small>(Note, you can change this after)</small>
          </div>
        )}
        <br />
        <Button1 style={{ width: "100%" }} onClick={copySiteSettings}>Copy</Button1>
      </div>


    );

    HandleShowModal();
  }

  const AddSiteToGroup = async () => {
    console.log(isMassAction)
    if (selectedGroup) {
      let body = {
        groupID: selectedGroup.id,
        groupName: selectedGroup.name,
        groupDevices: [UUID]
      }

      const response = await addSitesToGroup(apiData, body, dispatch);
      console.log(response)
      if (response.success) {
        setUpdate(update + 1);
        HandleCloseModal();
        setAddToGroupVisible(false)
        successModal("Site successfully added to group: " + selectedGroup.name, false);

        setSiteDevices((prevSiteDevices) =>
          prevSiteDevices.map((device) =>
            device.uuid === UUID ? { ...device, name: selectedGroup.name } : device
          )
        );
      } else {
        errorModal("Something went wrong, please try again", false);
      }
    } else {
      errorModal("Unable to find group, please try again", false);
    }
  }

  // ---------- carrys out clicked action in dropdown
  const UserActionHandler = (userAction, suspend, DeviceId, DeviceUUID, userID, DeviceName, DeviceKey, camectIntegationType, tag, row, DeviceDetails, type, subGroup, suspendUser) => {
    switch (userAction) {
      case 'Unsuspend Site':
      case 'Suspend Site':
        const SuspendDevice = async () => {
          const response = await suspendDevice(apiData, suspend, DeviceId, dispatch);
          if (response) {
            let status;

            if (row.status === "suspended") {
              status = "available"
            } else {
              status = "suspended"
            }
            setSiteDevices((prevSiteDevices) =>
              prevSiteDevices.map((device) =>
                device.uuid === DeviceUUID ? { ...device, status: status } : device
              )
            );
            successModal("Site is now " + status)
            setOpenDropdownRowId(null);
            setUpdate(prevUpdate => prevUpdate + 1);
          } else {
            errorModal("Something went wrong, please try again", false)
          }
        }
        SuspendDevice();
        break;
      case 'Clear Logs':
        const ClearLogs = () => {
          setOpenDropdownRowId(null);

          const HandleClearLogs = async () => {
            const response = await clearDeviceLogs(apiData, DeviceUUID, userID, dispatch);
            if (response.success) {
              HandleCloseModal();
              successModal("Logs cleared successfully", false)
            } else {
              errorModal("Something went wrong, please try again", false)
            }
          }

          const Cancel = () => {
            HandleCloseModal();
          }

          setModalTitle("Clear Logs");
          setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "content", justifyContent: "center", width: "100%", gap: "20px" }}>
              <div style={{ display: "flex", alignItems: "content", justifyContent: "center", width: "100%", gap: "3px" }}>
                <h4 style={{ margin: "0px" }}>{"Are you sure you want to clear Device: " + DeviceKey + " Log's. This action is "}</h4>
                <h4 style={{ margin: "0px", color: "red" }}>Permanent</h4>
                <h4 style={{ margin: "0px" }}>!</h4>
              </div>
              <div style={{ display: "flex", alignItems: "content", justifyContent: "center", width: "100%", gap: "10px" }}>
                <Button1 propsclassName={classes.CancelButton} onClick={Cancel}>Cancel</Button1>
                <Button1 propsclassName={classes.ClearLogs} onClick={() => HandleClearLogs()}>Clear Logs</Button1>
              </div>
            </div>
          )
          HandleShowModal()
        }
        ClearLogs();
        break;
      case 'Change portal name':
        const ChangeTag = async () => {
          setOpenDropdownRowId(null);
          setModalTitle("Change portal name")
          setModalComponent(
            <SetTag
              placeholder={tag}
              DeviceUUID={DeviceUUID}
              HandleCloseModal={HandleCloseModal}
              dispatch={dispatch} update={update}
              setUpdate={setUpdate}
              SiteDevices={SiteDevices}
              setSiteDevices={setSiteDevices}
              successModal={successModal}
              errorModal={errorModal}
            />)
          HandleShowModal()
        }
        ChangeTag();
        break;
        case 'Change serial number':
        const ChangeSerialNumber = async () => {
          setOpenDropdownRowId(null);
          setModalTitle("Change serial number")
          setModalComponent(
            <SetSerial
              placeholder={subGroup}
              DeviceUUID={DeviceUUID}
              HandleCloseModal={HandleCloseModal}
              dispatch={dispatch} update={update}
              setUpdate={setUpdate}
              SiteDevices={SiteDevices}
              setSiteDevices={setSiteDevices}
              successModal={successModal}
              errorModal={errorModal}
            />)
          HandleShowModal()
        }
        ChangeSerialNumber();
        break;
      case 'Change group':
        const ChangeOwner = async (DeviceKey) => {
          setModalTitle("Change group of: " + DeviceKey)
          setModalComponent(<DropDownForm apiData={apiData} DeviceUUID={DeviceUUID} companyName={""} NotificationTitle={""} label={"Please select a new site group below"} dropDownOptions={['EyeSpyFX', 'RE:SURE', 'PARFAS', 'PORTAL_SECURITY', 'DCC', 'SOLO', 'CSC', 'CPS', 'EES', 'WEEBIG', 'KNOWIO', '12TH_LOCK']} HandleCloseModal={HandleCloseModal} update={update} setUpdate={setUpdate} SiteDevices={SiteDevices} setSiteDevices={setSiteDevices} />)
          setOpenDropdownRowId(null);
          HandleShowModal()
        }
        ChangeOwner(DeviceKey);
        break;
      case 'Change camect integration type':
        const Changecamectintergrationtype = async () => {
          const CamectIntegationType = camectIntegationType == 2 ? 1 : 2;
          const notificationMessage = CamectIntegationType == 1 ? "Whole Camect" : "Per Cam Arming"
          const response = await changeCamectIntegration(apiData, DeviceUUID, CamectIntegationType, DeviceName, dispatch)
          if (response) {
            successModal("Camect integration changed to " + notificationMessage)
            DeviceDetails.camectIntegrationType = CamectIntegationType;
            row.deviceDetails = JSON.stringify(DeviceDetails);
            setOpenDropdownRowId(null);
          } else {
            errorModal("Failed to change camect integration type, please try again")
          }
        }
        Changecamectintergrationtype();
        break;
      case 'Copy site configuration':
        const Copydevicesettings = async (apiData, fromDeviceUUID) => {
          setDeviceKey(DeviceKey);
          dataManager.setItem('deviceUUIDToCopyFrom', DeviceUUID);
          dataManager.setItem('deviceIDToCopyFrom', DeviceId);
          setMyUserID(userID);
          setDeviceType(type);
          showCopySiteSettingsModal(DeviceKey, type);
        }
        Copydevicesettings(apiData, DeviceUUID);
        break;
      case 'Reboot site':
        const RebootDevice = async () => {
          const response = await rebootIPIODevice(apiData, DeviceUUID, userID, DeviceName);
          setOpenDropdownRowId(null);
          if (response) {
            successModal("Site rebooting...")
          } else {
            errorModal("Failed to reboot site, please try again")
          }
        }
        RebootDevice();
        break;
      case 'Reset site':
        const ResetDevice = async () => {
          dataManager.setItem('setPortalGroup', "")
          dataManager.setItem('changePortalGroupForReset', "")
          setModalTitle("Are you sure?")
          setModalComponent(
            <div>
              <div style={{ textAlign: "center" }}>
                <h2>Are you sure you want to reset: {DeviceKey}</h2>
              </div>
              <p style={{ textAlign: "center" }}>This will revert all settings & customisations to factory default.</p>
              <p style={{ textAlign: "center" }}>This action cannot be undone!</p>

              <br></br>
              <ChangeGroup
                apiData={apiData}
                DeviceUUID={""}
                companyName={""}
                NotificationTitle={""}
                label={"To change group, please select a new group below"}
                dropDownOptions={groups.map(group => group.name).sort((a, b) => a.localeCompare(b))}
                HandleCloseModal={HandleCloseModal}
                update={update}
                setUpdate={setUpdate}
                SiteDevices={SiteDevices}
                setSiteDevices={setSiteDevices}
              />
              <br></br>
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px"
              }}>
                <Button1 onClick={HandleCloseModal}>No, cancel</Button1>
                <Button1 onClick={() => resetSite(apiData, DeviceUUID, userID, DeviceName, dispatch)}>Yes, I'm sure</Button1>
              </div>
            </div>
          )
        }
        HandleShowModal();
        ResetDevice();
        break;
      case 'Add to group':
        console.log(row.uuid)
        setUUID(row.uuid)
        setAddToGroupVisible(true)
        //const ShowGroupsModal = async () => {
        //   const groupNames = groups.map(listOptions => listOptions.name);
        //   setModalTitle("Add site to group")
        //   setModalComponent(
        //     <div>
        //       <DropdownCustom label={"Please select a group below"} dropDownOptions={groupNames.sort((a, b) => a.localeCompare(b))} setSelectedGroup={setSelectedGroup} />
        //       <br></br>
        //       <Button1 onClick={() => AddSiteToGroup(row.uuid)}>Add to group</Button1>
        //     </div>

        //   )
        //   HandleShowModal();
        // }

        // ShowGroupsModal();
        
        break;
      case 'Change role':
        const HandleChangeUserAccess = async () => {
          const responseData = await changeRole(apiData, DeviceId, userID, row.role, row.userID, DeviceUUID, dispatch);
          if (responseData.success) {
            const newRole = row.role == 'user' ? 'manager' : 'user'
            const formattedNewRole = newRole == 'user' ? "app standard user" : "app manager"

            setSiteDevices((prevSiteDevices) =>
              prevSiteDevices.map((device) =>
                device.uuid === DeviceUUID ? { ...device, role: newRole } : device
              )
            );
            setOpenDropdownRowId(null);
            successModal(`User role successfully changed to ${formattedNewRole}`, false)
          } else {
            errorModal("Failed to change users role, please try again.", false)
          }
        }

        HandleChangeUserAccess()
        break;
      case 'Revoke access':
        const HandleRevokeUserAccess = async () => {
          const responseData = await removeUser(apiData, DeviceId, DeviceUUID, userID, row.userID, dispatch)
          if (responseData) {
            setSiteDevices((prevSiteDevices) =>
              prevSiteDevices.filter((device) => device.uuid !== DeviceUUID)
            );
            setOpenDropdownRowId(null);
            successModal("Access successfully revoked", false)
          } else {
            errorModal("Failed to revoke access, please try again.", false)
          }
        }
        HandleRevokeUserAccess();
        break;
      case 'Suspend access': 
      case 'Unsuspend access':
        suspendUser(apiData, row.userID, suspendUser, DeviceId).then((responseData) => {
            if (responseData) {
                setOpenDropdownRowId(null);
                
                successModal("Access changed successfully", false)
            }
        })
        break;
      default:
    }
  }

  const resetSite = async (apiData, DeviceUUID, userID, DeviceName, dispatch) => {
    console.log(dataManager.getItem('changePortalGroupForReset'))
    const response = await resetIPIODevice(apiData, DeviceUUID, userID, DeviceName, dataManager.getItem('changePortalGroupForReset'), dispatch)
    if (response.success) {
      successModal("Site reset successfully!", false)
      setPageFetchedIndex(pageFetchedIndex)
      //HERE
      if (dataManager.getItem('changePortalGroupForReset') !== "") {
        const updatedDevices = devices.map(device =>
          device.uuid === DeviceUUID ? { ...device, name: dataManager.getItem('changePortalGroupForReset'), active: 0 } : device
        );
        setSiteDevices(updatedDevices)
      } else {
        const updatedDevices = devices.map(device =>
          device.uuid === DeviceUUID ? { ...device, active: 0, tag: "", deviceName: "", userCount: 0 } : device
        );
        setSiteDevices(updatedDevices)
      }
    }
    setOpenDropdownRowId(null);
  }

  const successModal = (message, isCopyConfig) => {
    setModalTitle('Success')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.Icon} src={check}>
        </img>
        <br></br>
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
        </div>
        <br></br>
        <br></br>
        <div>
          {isCopyConfig && (<Button1 style={{ width: "100%" }} onClick={() => HandleUipiodOnClick(newSiteUUID)}>Go to new site</Button1>)}
          <br></br>
          {isCopyConfig && (<Button1 style={{ width: "100%" }} onClick={() => HandleUipiodOnClick(dataManager.getItem('deviceUUIDToCopyFrom'))}>Go to original site</Button1>)}
          <br></br>
          <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>Close</Button1>
        </div>
      </div>
    )
    HandleShowModal();
  }

  const errorModal = (message, isCopyConfig) => {
    setModalTitle('Error')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.Icon} src={fail}>
        </img>
        <br></br>
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
        </div>
        <br></br>
        <br></br>
        <div>
          {isCopyConfig && <Button1 onClick={copySiteSettings} style={{ width: "100%" }}>Try again</Button1>}
          <br></br>
          <Button1 style={{ width: "100%" }} onClick={HandleCloseModal}>Cancel</Button1>
        </div>
      </div>
    )
    HandleShowModal();
  }

  const loadingModal = (message) => {
    setModalTitle('Please wait...')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.Icon} src={loading}>
        </img>
        <br></br>
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
        </div>
        <br></br>
        <br></br>
      </div>
    )
    HandleShowModal();
  }

  const copySiteSettings = async () => {
    loadingModal("Copying site configuration, please wait...");

    const copyUsers = dataManager.getItem('copyUsersChecked');
    const fromUUID = dataManager.getItem('deviceUUIDToCopyFrom');
    let toUIPIOID = queryDeviceList;
    const siteName = dataManager.getItem('setNameCopyUsers');
    const auto = dataManager.getItem('autoChooseASite')
    let tag = ""
    let group = ""
    if (auto) {
      toUIPIOID = ""
    }

    console.log(dataManager.getItem('portalName'))
    if (dataManager.getItem('setPortalNameSelected')) {
      //set the name
      tag = dataManager.getItem('portalName')
    }
    console.log(tag)

    if (dataManager.getItem('setPortalGroupSelected')) {
      //set group
      group = dataManager.getItem('setPortalGroup')
    }

    console.log(dataManager.getItem('portalName'))

    loadingModal();

    const response = await copyIPIOSettings(apiData, fromUUID, toUIPIOID, tag, group, auto, dispatch);
    if (response.success) {
      newSiteUUID = response.data[0].uuid;
      if (copyUsers) {
        if (auto) {
          handleCopyUsers(siteName, auto, response.data[0].key);
        } else {
          handleCopyUsers(siteName, auto, "");
        }

        loadingModal("Site configuration copied successfully! Now copying users, please wait...")
      } else {
        if (auto) {
          successModal(`Site configuration copied successfully! \n${"Site ID: ", response.data[0].key}`, true);
        } else {
          successModal("Site configuration copied successfully!", true);
        }

        setPageFetchedIndex(pageFetchedIndex)
      }
    } else {
      //error
      if (auto) {
        errorModal("Failed to automatically copy site configuration. \nUnable to find a suitable site, please enter the Site ID manually", false)
      } else {
        errorModal("Failed to copy site configuration, please try again.", true);
      }
    }
  }

  const handleCopyUsers = async (siteName, auto, newUIPIOID) => {
    const deviceID = dataManager.getItem('deviceIDToCopyFrom');
    let response = "";
    if (auto) {
      response = await copyUsersToAnotherDevice(apiData, deviceID, newUIPIOID, siteName, userID, dispatch);
    } else {
      response = await copyUsersToAnotherDevice(apiData, deviceID, queryDeviceList, siteName, userID, dispatch);
    }
    if (response.success) {
      successModal("Site configuration & users copied successfully!", true)
      setPageFetchedIndex(pageFetchedIndex)
      dataManager.setItem('setNameCopyUsers', "")
    } else {
      errorModal("Failed to copy users, please try again.", false);
    }
  }

  const outputs =
  {
    output1: 1,
    output2: 0,
    output3: 0,
    output4: 1
  };

  const inputs =
  {
    input1: 1,
    input2: 1,
    input3: 1,
    input4: 1,
    input5: 0,
    input6: 1,
    input7: 1,
    input8: 0,
  };

  const handleCheckboxChange = (uuid, deviceID, deviceName) => {
    console.log("Here")
    if (!dataManager.getItem('isAddAccessMode')) {
      setCheckedItems((prevCheckedItems) => {
        if (prevCheckedItems.includes(uuid)) {
          return prevCheckedItems.filter((id) => id !== uuid);
        } else {
          return [...prevCheckedItems, uuid];
        }
      });
    } else {
      console.log("here")
      setCheckedItems((prevCheckedItems) => {
        if (prevCheckedItems.some((item) => item.deviceID === deviceID)) {
          return prevCheckedItems.filter((item) => item.deviceID !== deviceID);
        } else {
          return [...prevCheckedItems, { deviceID, deviceName }];
        }
      });
    }
  };

  const HandleSitesChange = (deviceUUID, deviceID, deviceName) => {
    console.log("here")
    setSitesToRemove((prevSitesToRemove) => {
      // Check if the combination of deviceUUID and deviceID already exists
      const exists = prevSitesToRemove.some(
        (site) => site.deviceUUID === deviceUUID && site.deviceID === deviceID
      );

      if (exists) {
        // Remove the item if it already exists
        return prevSitesToRemove.filter(
          (site) => site.deviceUUID !== deviceUUID || site.deviceID !== deviceID
        );
      } else {
        // Add the item if it doesn't exist
        return [...prevSitesToRemove, { deviceUUID, deviceID }];
      }
    });
  }

  const HandleSitesForGroupChange = (uuid) => {
    console.log("here")
    setSitesForGroup((prevSitesForGroup) => {
      if (prevSitesForGroup.includes(uuid)) {
        return prevSitesForGroup.filter((id) => id !== uuid);
      } else {
        return [...prevSitesForGroup, uuid];
      }
    });

  }

  useEffect(() => {
    console.log(checkedItems)
    dataManager.setSelectedSites(checkedItems)
  }, [checkedItems])

  const handleCopyUsersSelected = (event) => {
    setCopyUsersChecked(event.target.checked);
    dataManager.setItem('copyUsersChecked', event.target.checked);
    showCopySiteSettingsModal(deviceKey);
  }

  const handleSetPortalNameSelected = (event) => {
    dataManager.setItem('setPortalNameSelected', event.target.checked);
    showCopySiteSettingsModal(deviceKey);
  }

  const handleSetGroupSelected = (event) => {
    dataManager.setItem('setPortalGroupSelected', event.target.checked);
    showCopySiteSettingsModal(deviceKey);
  }

  const HandleSiteChecked = (rowData) => {
    setCheckedSites(prevCheckedSites => {
      const exists = prevCheckedSites.some(site => site.id === rowData.id);
      if (exists) {
        return prevCheckedSites.filter(site => site.id !== rowData.id);
      } else {
        return [...prevCheckedSites, rowData];
      }
    });
  }

  const HandleSelectAllSites = () => {
    if (selectAllSites) {
      setSelectAllSites(false)
      setCheckedSites([])
    } else {
      setSelectAllSites(true)
      setCheckedSites(SiteDevices)
    }
  }

  useEffect(() => {
    if (checkedSites.length > 0) {
      setShowMassSettings(true)
    } else {
      setShowMassSettings(false)
      setSelectedMassAction("")
    }
  }, [checkedSites])


  const HandleCamerasClick = (siteData) => {
    console.log(siteData)
    if (siteData.uuid) {
        dispatch(serviceActions.setDeviceUUID(siteData.uuid));
        navigate("/Dashboard/liveViewSites/Site/" + siteData.uuid, {
          state: siteData
        }); 
    }
    useSetCookie("SiteUUID", siteData.uuid, 1);
  }

  let tablecolumns = [
    {
      id: 'tag',
      header: () => (
        <div className={classes.tableTitleText}>
          {(!groupMode && !addAccessMode && showMassSelect) && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                onChange={e => HandleSelectAllSites()}
                checked={selectAllSites}>
              </Checkbox>
            </div>
          )}
          <h3 style={{ marginLeft: "20px" }}>Portal name</h3>
        </div>
      ),
      filterLabel: "Site name",
      accessorKey: 'tag',
      hidden: !columnVisibility['tag'] ?? false,
      cell: (row) => {
        const uuid = row.row.original.uuid;
        const deviceID = row.row.original.id;
        let deviceName = row.row.original.key;

        if (row.row.original.deviceName !== "") {
          deviceName = row.row.original.deviceName
        }

        if (row.row.original.tag !== "") {
          deviceName = row.row.original.tag
        }
        //const deviceName = row.row.original.tag;

        console.log(row.row.original)
        return (
          <div style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2
          }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {(groupMode || addAccessMode) && (
                <div style={{ marginRight: "10px" }}>  {/* Added margin to separate from the pill */}
                  <input
                    type="checkbox"
                    id={`checkbox-${uuid}`}
                    className={classes["circular-checkbox"]}
                    checked={(checkedItems.some((item) => item === row.row.original.uuid)) ||
                      (checkedItems.some((item) => item.deviceID === row.row.original.id))
                    }

                    onChange={() => handleCheckboxChange(uuid, deviceID, deviceName)}
                  />
                  <label
                    htmlFor={`checkbox-${uuid}`}
                    className={classes['custom-checkbox']}
                  />
                </div>
              )}


              {(!groupMode && !addAccessMode && showMassSelect) && (
                <div style={{ marginRight: "10px" }}>
                  <Checkbox
                    onChange={e => HandleSiteChecked(row.row.original)}
                    checked={checkedSites.some((item) => item.id === row.row.original.id)}>
                  </Checkbox>
                </div>
              )}

              <div onClick={() => HandleUipiodOnClick(uuid)} style={{ cursor: "pointer", width: "fit-content" }}>
                {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                  <Pill_Widget
                    boolean={true}
                    PillColor_IfTrue={"#919191"}
                    PillColor_IfFalse={"#6e6e6e"}
                    text_IfTrue={row.row.original.tag}
                    className={classes.PillHeight}
                  />
                )}
              </div>
            </div>
          </div>

        );
      },
    },
    {
      hidden: !columnVisibility['deviceName'] ?? false,
      id: 'deviceName',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>{isUsersSites ? 'Their app site name' : 'App name'}</h3>
        </div>
      ),
      filterLabel: "My site name",
      accessorKey: 'deviceName',
      cell: (row) => {
        return (
          <Link
            to={`/Dashboard/SiteView/${row.row.original.uuid}`}
            style={{
              display: 'block',
              maxWidth: '150px',
              overflow: 'hidden',
              whiteSpace: 'normal',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              textDecoration: 'none',
              color: 'inherit'
            }}
            className={classes.tableValueText}
          >
            {row.row.original.deviceName && row.row.original.deviceName.trim() !== "" && (
              <Pill_Widget
                boolean={true}
                PillColor_IfTrue={"#C3B1E1"}
                PillColor_IfFalse={"#6e6e6e"}
                text_IfTrue={row.row.original.deviceName}
                className={classes.PillHeight}
              />
            )}
          </Link>
        );
      }
    },
    {
      hidden: !columnVisibility['key'] ?? false,
      id: 'key',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site ID</h3>
        </div>
      ),
      filterLabel: "Site ID",
      accessorKey: 'key',
      cell: (row) => {
        // return (
        //   <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
        //     {row.row.original.key}
        //   </div>
        // )
        return (
          <Link
              to={`/Dashboard/SiteView/${row.row.original.uuid}`}
             className={classes.tableValueText}>
            {row.row.original.key}
          </Link>
        )
      }
    },
    {
      hidden: !columnVisibility['serial'] ?? false,
      id: 'serial',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>S/N</h3>
        </div>
      ),
      filterLabel: "Serial number",
      accessorKey: 'subGroup',
      cell: (row) => {
        const subGroup = row.row.original.subGroup;
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {subGroup != "" ? subGroup : "-"}
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['ip'] ?? false,
      id: 'ip',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>IP/Site Type</h3>
        </div>
      ),
      filterLabel: "IP address",
      accessorKey: 'ip',
      cell: (row) => {
        const isCC = row.row.original.type === "CC" ? true : false
        const isTypeS = row.row.original.type === "S" ? true : false
        const ipAddress = row.row.original.ip
        let text = ""
        let colour = ""
        let textColour = ""
        console.log(ipAddress)
        if (isCC) {
          colour = "#6996f1"
          textColour = "#ffffffff"
          if (ipAddress == "10.250.20.173") {
            text = "CC Server 1"
          } else if (ipAddress == "10.250.20.155") {
            text = "CC Server 2"
          } else if (ipAddress == "10.250.20.175") {
            text = "CC Server 3"
          } else if (ipAddress == "10.250.20.165") {
            text = "CC Server 4"
          } else if (ipAddress == "10.250.20.224") {
            text = "CC Server 5"
          } else if (ipAddress == "10.250.20.98") {
            text = "CC Server 6"
          } else if (ipAddress == "10.250.20.184") {
            text = "CC Server 7"
          } else if (ipAddress == "10.250.20.130") {
            text = "CC Server 8"
          } else if (ipAddress == "10.250.20.21") {
            text = "CC Server 9"
          } else if (ipAddress == "10.250.1.22") {
            text = "Upgrade Server"
          } else if (ipAddress == "10.250.1.64") {
            text = "FW Dev Server"
          } else if (ipAddress == "10.250.20.178") {
            text = "CC Server 10"
          } else if (ipAddress == "10.250.1.251") {
            text = "Davantis"
          }
        } else if (isTypeS){
            text = "G2CC"
            colour = "#71e268"
            textColour = "#2f2f2f"
        } else {
          colour = "#626a67"
          textColour = "#ffffffff"
          text = ipAddress
        }
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget_2
             pillColour={colour}
             textColour={textColour}
             text={text} 
            />
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['firmware'] ?? false,
      id: 'firmware',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>FW</h3>
        </div>
      ),
      filterLabel: "Firmware",
      accessorKey: 'firmware',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {row.row.original.firmware}
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['status'] ?? false,
      id: 'status',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Status</h3>
        </div>
      ),
      filterLabel: "Status",
      accessorKey: 'status',
      cell: (row) => {
        const OnlineStatus = row.row.original.online == "YES" ? true : false
        const SuspendedStatus = row.row.original.status == "suspended";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget
              boolean={OnlineStatus}
              PillColor_IfTrue={"#22ca80"}
              PillColor_IfFalse={"#ff4f70"}
              text_IfTrue={"Online"}
              text_IfFalse={UseDateFormat(row.row.original.lastLoggedIn)}
              className={classes.PillHeight}
            />

            {SuspendedStatus &&
              <Pill_Widget
                boolean={SuspendedStatus}
                PillColor_IfTrue={"black"}
                PillColor_IfFalse={"none"}
                text_IfTrue={"Suspended"}
                className={classes.PillHeight}
              />
            }
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['userCount'] ?? false,
      id: 'userCount',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Users</h3>
        </div>
      ),
      filterLabel: "User count",
      accessorKey: 'userCount',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
            {row.row.original.userCount}
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['Devices'] ?? false,
      id: 'Devices',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Devices</h3>
        </div>
      ),
      filterLabel: "Devices",
      accessorKey: 'connectedDevices',
      cell: (row) => {
        console.log(row.row.original.connectedDevices)
        const hasGateway = row.row.original.connectedDevices?.includes("Gateway")
        const hasAjax = row.row.original.connectedDevices?.includes("AJAX")
        const hasDahua = row.row.original.connectedDevices?.includes("DAHUA")
        const hasHik = row.row.original.connectedDevices?.includes("HIKVISION")
        const hasAibox = row.row.original.connectedDevices?.includes("AIBOX")

        return (
          <div className={classes.tableValueTextBold}>
            {hasGateway == true && <img style={{height: "25px", width:"25px", marginRight:"5px"}}src={gateway_icon}></img>}
            {hasAjax == true && <img style={{height: "25px", width:"25px", marginRight:"5px"}}src={ajax_icon}></img>}
            {hasDahua == true && <img style={{height: "25px", width:"25px", marginRight:"5px"}}src={dahua_icon}></img>}
            {hasHik == true && <img style={{height: "25px", width:"25px", marginRight:"5px"}}src={hik_icon}></img>}
            {hasAibox == true && <img style={{height: "25px", width:"25px", marginRight:"5px"}}src={aibox_icon}></img>}
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['states'] ?? false,
      id: 'states',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>States</h3>
        </div>
      ),
      filterLabel: "States",
      cell: (row) => {
        const data = parsedData[row.row.index]
        console.log(data)
        return (
          <div className={classes["bottom-wrapper"]}>
            <div>
              <ul className={classes.outputs}>
                <OutputPinCircle outputs={outputs} OutputPins={data.OutputPins} />
              </ul>
            </div>
            <div className={classes["bottom-wrapper_divider"]} />
            <div>
              <ul className={classes.inputs}>
                <InputPinCircle inputs={inputs} InputPins={data.InputPins} />
              </ul>
            </div>
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['group'] ?? false,
      id: 'group',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Group</h3>
        </div>
      ),
      filterLabel: "Group",
      accessorKey: 'name',
      cell: (row) => {
        let companyName = row.row.original.name;

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (

          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={row.row.original.name}
              className={classes.PillHeight}
            />
          </div>
        )

      }
    },
    {
      hidden: !columnVisibility['active'] ?? false,
      id: 'Active',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Active</h3>
        </div>
      ),
      filterLabel: "Active",
      accessorKey: 'active',
      cell: (row) => {
        const active = row.row.original.active == "1" ? true : false
        return (
          <div className={classes.tableValueText}>
              <InputSwitch checked={active} onChange={() => HandleSingleDeactivateSite(row.row.original)}/>
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['actions'] ?? false,
      id: 'actions',
      filterLabel: "Settings",
      cell: (row) => {
        let items = [
          {
            image: SuspendIcon,
            title:
              row.row.original.status !== "suspended"
                ? "Suspend Site"
                : "Unsuspend Site",
          },
          {
            image: ClearLogsIcon,
            title: "Clear Logs",
          },
          {
            image: ChangePortalNameIcon,
            title: "Change portal name",
          },
          {
            image: ChangeSerialIcon,
            title: "Change serial number",
          },
          {
            image: AddToGroupIcon,
            title: "Add to group"
          }
        ];

        const firmware = row.row.original.firmware.split('.')
        const firmwareMajor = firmware[0]
        const firmwareMinor = firmware[1]
        const DeviceType = row.row.original.type;
        const isOnline = row.row.original.online == "YES" ? true : false;

        const deviceDetails = JSON.parse(row.row.original.deviceDetails);
        const camectIntegationType = deviceDetails.camectIntegrationType;

        // if ((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 9)) && DeviceType != 'V') {
        //   items.splice(4, 0, {
        //     image: CamectIntegrationIcon,
        //     title: "Change camect integration type",
        //   },);
        // }

        if ((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 7))) {
          items.splice(5, 0, {
            image: CopyConfigIcon,
            title: "Copy site configuration",
          });
        }

        if (isOnline && DeviceType != "CC") {
          items.splice(6, 0, {
            image: RebootIcon,
            title: "Reboot site",
          })
        }

        if (isOnline) {
          items.splice(7, 0,
            {
              image: ResetIcon,
              title: "Reset site",
            });
        }

        const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
        const suspend = row.row.original.status == "suspended" ? "available" : "suspended";

        return <DropdownList
          item={row.row.id}
          icon={SettingsCog}
          onClick={handleSettingsClick}
          ifSettingsCogIsClicked={ifSettingsCogIsClicked}
          ref={dropdownRef}
          title={"Actions"}
          className={classes.container}
          onUserActionClick={(userAction) =>
            UserActionHandler(
              userAction,
              suspend,
              row.row.original.id,
              row.row.original.uuid,
              userID,
              row.row.original.name,
              row.row.original.key,
              camectIntegationType,
              row.row.original.tag,
              row.row.original,
              deviceDetails,
              row.row.original.type,
              row.row.original.subGroup
            )
          }
          listItems={items}
        />
      },
    }
  ];

  let tablecolumnsLiveViewOnly = [
    {
      id: 'tag',
      header: () => (
        <div className={classes.tableTitleText}>
          {(!groupMode && !addAccessMode && showMassSelect) && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                onChange={e => HandleSelectAllSites()}
                checked={selectAllSites}>
              </Checkbox>
            </div>
          )}
          <h3 style={{ marginLeft: "20px" }}>Portal name</h3>
        </div>
      ),
      filterLabel: "Site name",
      accessorKey: 'tag',
      hidden: !columnVisibility['tag'] ?? false,
      cell: (row) => {
        const uuid = row.row.original.uuid;
        const deviceID = row.row.original.id;
        let deviceName = row.row.original.key;

        if (row.row.original.deviceName !== "") {
          deviceName = row.row.original.deviceName
        }

        if (row.row.original.tag !== "") {
          deviceName = row.row.original.tag
        }
        //const deviceName = row.row.original.tag;

        console.log(row.row.original)
        return (
          <div style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2
          }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {(groupMode || addAccessMode) && (
                <div style={{ marginRight: "10px" }}>  {/* Added margin to separate from the pill */}
                  <input
                    type="checkbox"
                    id={`checkbox-${uuid}`}
                    className={classes["circular-checkbox"]}
                    checked={(checkedItems.some((item) => item === row.row.original.uuid)) ||
                      (checkedItems.some((item) => item.deviceID === row.row.original.id))
                    }

                    onChange={() => handleCheckboxChange(uuid, deviceID, deviceName)}
                  />
                  <label
                    htmlFor={`checkbox-${uuid}`}
                    className={classes['custom-checkbox']}
                  />
                </div>
              )}


              {(!groupMode && !addAccessMode && showMassSelect) && (
                <div style={{ marginRight: "10px" }}>
                  <Checkbox
                    onChange={e => HandleSiteChecked(row.row.original)}
                    checked={checkedSites.some((item) => item.id === row.row.original.id)}>
                  </Checkbox>
                </div>
              )}

              <div onClick={() => HandleUipiodOnClick(uuid)} style={{ cursor: "pointer", width: "fit-content" }}>
                {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                  <Pill_Widget
                    boolean={true}
                    PillColor_IfTrue={"#919191"}
                    PillColor_IfFalse={"#6e6e6e"}
                    text_IfTrue={row.row.original.tag}
                    className={classes.PillHeight}
                  />
                )}
              </div>
            </div>
          </div>

        );
      },
    },
  
    {
      hidden: !columnVisibility['key'] ?? false,
      id: 'key',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site ID</h3>
        </div>
      ),
      filterLabel: "Site ID",
      accessorKey: 'key',
      cell: (row) => {
        // return (
        //   <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
        //     {row.row.original.key}
        //   </div>
        // )
        return (
          <Link
              to={`/Dashboard/SiteView/${row.row.original.uuid}`}
             className={classes.tableValueText}>
            {row.row.original.key}
          </Link>
        )
      }
    },
    {
      hidden: !columnVisibility['linked'] ?? false,
      id: 'linked',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Camera count</h3>
        </div>
      ),
      filterLabel: "cameraCount",
      accessorKey: 'cameraCount',
      cell: (row) => {
        const hasCameras = row.row.original.cameraCount > 0 ? true : false
        return (
          <div onClick={() => HandleCamerasClick(row.row.original)} className={classes.tableValueText}>
            <Pill_Widget
              boolean={hasCameras}
              PillColor_IfTrue={"#22ca80"}
              PillColor_IfFalse={"#ff4f70"}
              text_IfTrue={row.row.original.cameraCount}
              text_IfFalse={"0"}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
  
    {
      hidden: !columnVisibility['serial'] ?? false,
      id: 'serial',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>S/N</h3>
        </div>
      ),
      filterLabel: "Serial number",
      accessorKey: 'subGroup',
      cell: (row) => {
        const subGroup = row.row.original.subGroup;
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {subGroup != "" ? subGroup : "-"}
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['ip'] ?? false,
      id: 'ip',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>IP/Site Type</h3>
        </div>
      ),
      filterLabel: "IP address",
      accessorKey: 'ip',
      cell: (row) => {
        const isCC = row.row.original.type === "CC" ? true : false
        const isTypeS = row.row.original.type === "S" ? true : false
        const ipAddress = row.row.original.ip
        let text = ""
        let colour = ""
        let textColour = ""
        console.log(ipAddress)
        if (isCC) {
          colour = "#6996f1"
          textColour = "#ffffffff"
          if (ipAddress == "10.250.20.173") {
            text = "CC Server 1"
          } else if (ipAddress == "10.250.20.155") {
            text = "CC Server 2"
          } else if (ipAddress == "10.250.20.175") {
            text = "CC Server 3"
          } else if (ipAddress == "10.250.20.165") {
            text = "CC Server 4"
          } else if (ipAddress == "10.250.20.224") {
            text = "CC Server 5"
          } else if (ipAddress == "10.250.20.98") {
            text = "CC Server 6"
          } else if (ipAddress == "10.250.20.184") {
            text = "CC Server 7"
          } else if (ipAddress == "10.250.20.130") {
            text = "CC Server 8"
          } else if (ipAddress == "10.250.20.21") {
            text = "CC Server 9"
          } else if (ipAddress == "10.250.1.22") {
            text = "Upgrade Server"
          } else if (ipAddress == "10.250.1.64") {
            text = "FW Dev Server"
          } else if (ipAddress == "10.250.20.178") {
            text = "CC Server 10"
          } else if (ipAddress == "10.250.1.251") {
            text = "Davantis"
          }
        } else if (isTypeS){
            text = "G2CC"
            colour = "#71e268"
            textColour = "#2f2f2f"
        } else {
          colour = "#626a67"
          textColour = "#ffffffff"
          text = ipAddress
        }
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget_2
             pillColour={colour}
             textColour={textColour}
             text={text} 
            />
          </div>
        )
      }
    },
 
    {
      hidden: !columnVisibility['status'] ?? false,
      id: 'status',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Status</h3>
        </div>
      ),
      filterLabel: "Status",
      accessorKey: 'status',
      cell: (row) => {
        const OnlineStatus = row.row.original.online == "YES" ? true : false
        const SuspendedStatus = row.row.original.status == "suspended";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget
              boolean={OnlineStatus}
              PillColor_IfTrue={"#22ca80"}
              PillColor_IfFalse={"#ff4f70"}
              text_IfTrue={"Online"}
              text_IfFalse={UseDateFormat(row.row.original.lastLoggedIn)}
              className={classes.PillHeight}
            />

            {SuspendedStatus &&
              <Pill_Widget
                boolean={SuspendedStatus}
                PillColor_IfTrue={"black"}
                PillColor_IfFalse={"none"}
                text_IfTrue={"Suspended"}
                className={classes.PillHeight}
              />
            }
          </div>
        )
      }
    },
  
 
    {
      hidden: !columnVisibility['group'] ?? false,
      id: 'group',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Group</h3>
        </div>
      ),
      filterLabel: "Group",
      accessorKey: 'name',
      cell: (row) => {
        let companyName = row.row.original.name;

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (

          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={row.row.original.name}
              className={classes.PillHeight}
            />
          </div>
        )

      }
    },
    {
      hidden: !columnVisibility['active'] ?? false,
      id: 'Active',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Active</h3>
        </div>
      ),
      filterLabel: "Active",
      accessorKey: 'active',
      cell: (row) => {
        const active = row.row.original.active == "1" ? true : false
        return (
          <div className={classes.tableValueText}>
              <InputSwitch checked={active} onChange={() => HandleSingleDeactivateSite(row.row.original)}/>
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['actions'] ?? false,
      id: 'actions',
      filterLabel: "Settings",
      cell: (row) => {
        let items = [
          {
            image: SuspendIcon,
            title:
              row.row.original.status !== "suspended"
                ? "Suspend Site"
                : "Unsuspend Site",
          },
          {
            image: ClearLogsIcon,
            title: "Clear Logs",
          },
          {
            image: ChangePortalNameIcon,
            title: "Change portal name",
          },
          {
            image: ChangeSerialIcon,
            title: "Change serial number",
          },
          {
            image: AddToGroupIcon,
            title: "Add to group"
          }
        ];

        const firmware = row.row.original.firmware.split('.')
        const firmwareMajor = firmware[0]
        const firmwareMinor = firmware[1]
        const DeviceType = row.row.original.type;
        const isOnline = row.row.original.online == "YES" ? true : false;

        const deviceDetails = JSON.parse(row.row.original.deviceDetails);
        const camectIntegationType = deviceDetails.camectIntegrationType;

        // if ((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 9)) && DeviceType != 'V') {
        //   items.splice(4, 0, {
        //     image: CamectIntegrationIcon,
        //     title: "Change camect integration type",
        //   },);
        // }

        if ((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 7))) {
          items.splice(5, 0, {
            image: CopyConfigIcon,
            title: "Copy site configuration",
          });
        }

        if (isOnline && DeviceType != "CC") {
          items.splice(6, 0, {
            image: RebootIcon,
            title: "Reboot site",
          })
        }

        if (isOnline) {
          items.splice(7, 0,
            {
              image: ResetIcon,
              title: "Reset site",
            });
        }

        const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
        const suspend = row.row.original.status == "suspended" ? "available" : "suspended";

        return <DropdownList
          item={row.row.id}
          icon={SettingsCog}
          onClick={handleSettingsClick}
          ifSettingsCogIsClicked={ifSettingsCogIsClicked}
          ref={dropdownRef}
          title={"Actions"}
          className={classes.container}
          onUserActionClick={(userAction) =>
            UserActionHandler(
              userAction,
              suspend,
              row.row.original.id,
              row.row.original.uuid,
              userID,
              row.row.original.name,
              row.row.original.key,
              camectIntegationType,
              row.row.original.tag,
              row.row.original,
              deviceDetails,
              row.row.original.type,
              row.row.original.subGroup
            )
          }
          listItems={items}
        />
      },
    }
  ];

  const HandleGroupOnClick = (groupName) => {
    const groupClicked = groups.find(g => g.name === groupName);

    if (groupClicked) {
        dataManager.setItem('groupClicked', groupClicked.name)   
        dataManager.setItem('groupPath', groupClicked.group_path)
        dataManager.setItem('groupClickedID', groupClicked.id)   
        navigate("/Dashboard/Groups/GroupSites")
    }
  }

  let tableColumnsOfflineOnly = [
    {
      id: 'tag',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Portal name ⇅</h3>
        </div>
      ),
      filterLabel: "Site name",
      accessorKey: 'tag',
      hidden: !columnVisibility['tag'] ?? false,
      cell: (row) => {
        const uuid = row.row.original.uuid;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            {groupMode || addAccessMode && (
              <div style={{ marginLeft: "10px", marginTop: "3px", marginRight: "20px" }}>
                <input
                  type="checkbox"
                  id={`checkbox-${uuid}`}
                  className={classes["circular-checkbox"]}
                  checked={checkedItems.some((item) => item === row.row.original.uuid)}
                  onChange={() => handleCheckboxChange(uuid)}
                />
                <label
                  htmlFor={`checkbox-${uuid}`}
                  className={classes['custom-checkbox']}
                />
              </div>
            )}
            <div onClick={() => HandleUipiodOnClick(uuid)} style={{ cursor: "pointer", width: "fit-content" }}>
              {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                <Pill_Widget
                  boolean={true}
                  PillColor_IfTrue={"#919191"}
                  PillColor_IfFalse={"#6e6e6e"}
                  text_IfTrue={row.row.original.tag}
                  className={classes.PillHeight}
                />
              )}
            </div>
          </div>
        );
      },
    },
    {
      hidden: !columnVisibility['deviceName'] ?? false,
      id: 'deviceName',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>{isUsersSites ? 'Their app site name ⇅' : 'My app site name ⇅'}</h3>
        </div>
      ),
      filterLabel: "My site name",
      accessorKey: 'deviceName',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {row.row.original.deviceName && row.row.original.deviceName.trim() !== "" && (
              <Pill_Widget
                boolean={true}
                PillColor_IfTrue={"#C3B1E1"}
                PillColor_IfFalse={"#6e6e6e"}
                text_IfTrue={row.row.original.deviceName}
                className={classes.PillHeight}
              />
            )}
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['key'] ?? false,
      id: 'key',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Site ID ⇅</h3>
        </div>
      ),
      filterLabel: "Site ID",
      accessorKey: 'key',
      cell: (row) => {

        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
            {row.row.original.key}
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['offlineSince'] ?? false,
      id: 'offlineSince',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Offline since ⇅</h3>
        </div>
      ),
      filterLabel: "Offline Since",
      accessorKey: 'lastLoggedIn',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget
              PillColor_IfTrue={"#ff4f70"}
              PillColor_IfFalse={"#ff4f70"}
              text_IfTrue={UseDateFormat(row.row.original.lastLoggedIn)}
              text_IfFalse={UseDateFormat(row.row.original.lastLoggedIn)}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['serial'] ?? false,
      id: 'serial',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Serial number ⇅</h3>
        </div>
      ),
      filterLabel: "Serial number",
      accessorKey: 'subGroup',
      cell: (row) => {
        const subGroup = row.row.original.subGroup;
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {subGroup != "" ? subGroup : "-"}
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['ip'] ?? false,
      id: 'ip',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>IP address ⇅</h3>
        </div>
      ),
      filterLabel: "IP address",
      accessorKey: 'ip',
      cell: (row) => {
        const isCC = row.row.original.type === "CC" ? true : false
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget
              boolean={isCC}
              PillColor_IfTrue={"#6996f1"}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={"IPIO CC"}
              text_IfFalse={row.row.original.ip}
              className={classes.PillHeight} />
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['firmware'] ?? false,
      id: 'firmware',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Firmware ⇅</h3>
        </div>
      ),
      filterLabel: "Firmware",
      accessorKey: 'firmware',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {row.row.original.firmware}
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['userCount'] ?? false,
      id: 'userCount',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Users ⇅</h3>
        </div>
      ),
      filterLabel: "User count",
      accessorKey: 'userCount',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
            {row.row.original.userCount}
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['group'] ?? false,
      id: 'group',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Group ⇅</h3>
        </div>
      ),
      filterLabel: "Group",
      accessorKey: 'name',
      cell: (row) => {
        let companyName = row.row.original.name;
        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div onClick={() => HandleGroupOnClick(row.row.original.name)} style={{ cursor: "pointer", width: "fit-content", color: "white", fontWeight: "600" }}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={row.row.original.name}
              className={classes.PillHeight} />
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['active'] ?? false,
      id: 'Active',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Active</h3>
        </div>
      ),
      filterLabel: "Active",
      accessorKey: 'active',
      cell: (row) => {
        const active = row.row.original.active == "1" ? true : false
        return (
          <div className={classes.tableValueText}>
              <InputSwitch checked={active} onChange={() => HandleSingleDeactivateSite(row.row.original)}/>
          </div>
        )
      }
    },
  ];

  let tableColumnsUserSites = [
    {
      id: 'tag',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Portal name</h3>
        </div>
      ),
      filterLabel: "Site name",
      accessorKey: 'tag',
      hidden: !columnVisibility['tag'] ?? false,
      cell: (row) => {
        const uuid = row.row.original.uuid;
        const deviceID = row.row.original.id;
        let deviceName = row.row.original.key;

        if (row.row.original.deviceName !== "") {
          deviceName = row.row.original.deviceName
        }

        if (row.row.original.tag !== "") {
          deviceName = row.row.original.tag
        }


        console.log(deviceID)
        return (
          <div style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2
          }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {(editUserAccess && !sitesForGroupMode) && (
                <div style={{ marginRight: "10px" }}>  {/* Added marginRight to separate from the pill */}
                  <input
                    type="checkbox"
                    id={`checkbox-${uuid}`}
                    className={classes["circular-checkbox"]}
                    checked={sitesToRemove.some(
                      (item) => item.deviceUUID === row.row.original.uuid && item.deviceID === row.row.original.deviceID
                    )}
                    onChange={() => HandleSitesChange(uuid, deviceID, deviceName)}
                  />
                  <label
                    htmlFor={`checkbox-${uuid}`}
                    className={classes['custom-checkbox']}
                  />
                </div>
              )}

              {(!editUserAccess && sitesForGroupMode) && (
                <div style={{ marginRight: "10px" }}>  {/* Added marginRight to separate from the pill */}
                  <input
                    type="checkbox"
                    id={`checkbox-${uuid}`}
                    className={classes["circular-checkbox"]}
                    checked={sitesForGroup.some(
                      (item) => item === row.row.original.uuid
                    )}
                    onChange={() => HandleSitesForGroupChange(uuid)}
                  />
                  <label
                    htmlFor={`checkbox-${uuid}`}
                    className={classes['custom-checkbox']}
                  />
                </div>
              )}

              <div onClick={() => HandleUipiodOnClick(uuid)} style={{ cursor: "pointer", width: "fit-content" }}>
                {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                  <Pill_Widget
                    boolean={true}
                    PillColor_IfTrue={"#919191"}
                    PillColor_IfFalse={"#6e6e6e"}
                    text_IfTrue={row.row.original.tag}
                    className={classes.PillHeight}
                  />
                )}
              </div>
            </div>
          </div>

        );
      },
    },
    {
      hidden: !columnVisibility['deviceName'] ?? false,
      id: 'deviceName',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Their app site name</h3>
        </div>
      ),
      filterLabel: "My site name",
      accessorKey: 'deviceName',
      cell: (row) => {
        return (
          <div style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2
          }} onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {row.row.original.deviceName && row.row.original.deviceName.trim() !== "" && (
              <Pill_Widget
                boolean={true}
                PillColor_IfTrue={"#C3B1E1"}
                PillColor_IfFalse={"#6e6e6e"}
                text_IfTrue={row.row.original.deviceName}
                className={classes.PillHeight}
              />
            )}
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['key'] ?? false,
      id: 'key',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site ID</h3>
        </div>
      ),
      filterLabel: "Site ID",
      accessorKey: 'key',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
            {row.row.original.key}
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['serial'] ?? false,
      id: 'serial',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Serial number</h3>
        </div>
      ),
      filterLabel: "Serial number",
      accessorKey: 'subGroup',
      cell: (row) => {
        const subGroup = row.row.original.subGroup;
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {subGroup != "" ? subGroup : "-"}
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['ip'] ?? false,
      id: 'ip',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>IP/Site Type</h3>
        </div>
      ),
      filterLabel: "IP address",
      accessorKey: 'ip',
      cell: (row) => {
        const isCC = row.row.original.type === "CC" ? true : false
        const isTypeS = row.row.original.type === "S" ? true : false
        const ipAddress = row.row.original.ip
        let text = ""
        let colour = ""
        let textColour = ""
        console.log(ipAddress)
        if (isCC) {
          colour = "#6996f1"
          textColour = "#ffffffff"
          if (ipAddress == "10.250.20.173") {
            text = "CC Server 1"
          } else if (ipAddress == "10.250.20.155") {
            text = "CC Server 2"
          } else if (ipAddress == "10.250.20.175") {
            text = "CC Server 3"
          } else if (ipAddress == "10.250.20.165") {
            text = "CC Server 4"
          } else if (ipAddress == "10.250.20.224") {
            text = "CC Server 5"
          } else if (ipAddress == "10.250.20.98") {
            text = "CC Server 6"
          } else if (ipAddress == "10.250.20.184") {
            text = "CC Server 7"
          } else if (ipAddress == "10.250.20.130") {
            text = "CC Server 8"
          } else if (ipAddress == "10.250.20.21") {
            text = "CC Server 9"
          } else if (ipAddress == "10.250.1.22") {
            text = "Upgrade Server"
          } else if (ipAddress == "10.250.1.64") {
            text = "FW Dev Server"
          } else if (ipAddress == "10.250.20.178") {
            text = "CC Server 10"
          } else if (ipAddress == "10.250.1.251") {
            text = "Davantis"
          }
        } else if (isTypeS){
            text = "G2CC"
            colour = "#71e268"
            textColour = "#2f2f2f"
        } else {
          colour = "#626a67"
          textColour = "#ffffffff"
          text = ipAddress
        }
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget_2
             pillColour={colour}
             textColour={textColour}
             text={text} 
            />
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['role'] ?? false,
      id: 'role',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Role</h3>
        </div>
      ),
      filterLabel: "role",
      accessorKey: 'role',
      cell: (row) => {
        let newRole;
        switch (row.row.original.role) {
          case 'user':
            newRole = "App standard user"
            break;
          case 'manager':
            newRole = "App manager"
            if (row.row.original.liveViewAccess == 1){
              newRole = "Manager Plus"
            }
        }
        const setPillColour = row.row.original.role == 'user' ? true : false
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget
              boolean={setPillColour}
              PillColor_IfTrue={"#9c9c9c"}
              PillColor_IfFalse={"#1e82d4"}
              text_IfTrue={newRole}
              text_IfFalse={newRole}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['invitedBy'] ?? false,
      id: 'invitedBy',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Invited by</h3>
        </div>
      ),
      filterLabel: "invitedby",
      accessorKey: 'invitedByName',
      cell: (row) => {

        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
            {row.row.original.invitedByName}
          </div>
        )

      }
    },
    {
      hidden: !columnVisibility['status'] ?? false,
      id: 'status',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Status</h3>
        </div>
      ),
      filterLabel: "Status",
      accessorKey: 'status',
      cell: (row) => {
        const OnlineStatus = row.row.original.online == "YES" ? true : false
        const SuspendedStatus = row.row.original.status == "suspended";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget
              boolean={OnlineStatus}
              PillColor_IfTrue={"#22ca80"}
              PillColor_IfFalse={"#ff4f70"}
              text_IfTrue={"Online"}
              text_IfFalse={"Offline"}
              className={classes.PillHeight}
            />

            {SuspendedStatus &&
              <Pill_Widget
                boolean={SuspendedStatus}
                PillColor_IfTrue={"black"}
                PillColor_IfFalse={"none"}
                text_IfTrue={"Suspended"}
                className={classes.PillHeight}
              />
            }
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['group'] ?? false,
      id: 'group',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Group</h3>
        </div>
      ),
      filterLabel: "Group",
      accessorKey: 'name',
      cell: (row) => {
        let companyName = row.row.original.name;
        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={row.row.original.name}
              className={classes.PillHeight} />
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['active'] ?? false,
      id: 'Active',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Active</h3>
        </div>
      ),
      filterLabel: "Active",
      accessorKey: 'active',
      cell: (row) => {
        const active = row.row.original.active == "1" ? true : false
        return (
          <div className={classes.tableValueText}>
             <InputSwitch checked={active} onChange={() => HandleSingleDeactivateSite(row.row.original)}/>
          </div>
        )
      }
    },
    {
      hidden: !columnVisibility['actions'] ?? false,
      id: 'actions',
      filterLabel: "Settings",
      cell: (row) => {
        let items = [
          {
            image: revokeAccess,
            title: "Revoke access"
          },
          {
            image: ChangeRole,
            title: "Change role"
          },
          { divider: true },
          {
            image: SuspendIcon,
            title:
              row.row.original.status !== "suspended"
                ? "Suspend Site"
                : "Unsuspend Site",
          },
          {
            image: ClearLogsIcon,
            title: "Clear Logs",
          },
          {
            image: ChangePortalNameIcon,
            title: "Change portal name",
          },
          {
            image: AddToGroupIcon,
            title: "Add to group"
          }
        ];

        const firmware = row.row.original.firmware.split('.')
        const firmwareMajor = firmware[0]
        const firmwareMinor = firmware[1]
        const DeviceType = row.row.original.type;
        const isOnline = row.row.original.online == "YES" ? true : false;

        const deviceDetails = JSON.parse(row.row.original.deviceDetails);
        const camectIntegationType = deviceDetails.camectIntegrationType;

        if ((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 9)) && DeviceType != 'V') {
          items.splice(4, 0, {
            image: CamectIntegrationIcon,
            title: "Change camect integration type",
          },);
        }

        if ((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 7))) {
          items.splice(5, 0, {
            image: CopyConfigIcon,
            title: "Copy site configuration",
          });
        }

        if (isOnline && DeviceType != "CC") {
          items.splice(6, 0, {
            image: RebootIcon,
            title: "Reboot site",
          })
        }

        if (isOnline) {
          items.splice(7, 0,
            {
              image: ResetIcon,
              title: "Reset site",
            });
        }

        const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
        const suspend = row.row.original.status == "suspended" ? "available" : "suspended";
        console.log(row.row.original)
        return <DropdownList
          item={row.row.id}
          icon={SettingsCog}
          onClick={handleSettingsClick}
          ifSettingsCogIsClicked={ifSettingsCogIsClicked}
          ref={dropdownRef}
          title={"Actions"}
          className={classes.container}
          onUserActionClick={(userAction) =>
            UserActionHandler(
              userAction,
              suspend,
              row.row.original.id,
              row.row.original.uuid,
              userID,
              row.row.original.name,
              row.row.original.key,
              camectIntegationType,
              row.row.original.tag,
              row.row.original,
              deviceDetails,
              row.row.original.type,
              1
            )
          }
          listItems={items}
        />
      },
    }
  ]

  const tableColumnsFiltered = tablecolumns.filter(column => !column.hidden);

  if (offlineOnly) {
    tablecolumns = tableColumnsOfflineOnly
  }
  if (isUsersSites) {
    tablecolumns = tableColumnsUserSites
  }
  if(liveViewOnly){
    tablecolumns = tablecolumnsLiveViewOnly
  }
  let tableData = SiteDevices;

  useEffect(() => {
    if (selectAllCancelled) {
      setSelectAll(false)
    }
  }, [selectAllCancelled])

  const HandleSelectAll = () => {
    if (selectAll == null || !selectAll) {
      setSelectAll(true)
      setShowMassSettings(true)
    } else if (selectAll) {
      setSelectAll(false)
      setShowMassSettings(false)
    }
  }

  const ShowActionCompleteModal = (passCount, failCount, action) => {
    setCheckedSites([])
    setSelectedMassAction("")
    dataManager.setItem('selectedGroup', "")
    setModalTitle("Complete")
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.ModalIcon} src={check}>
        </img>
        <br></br>
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>Successfully {action} {passCount} sites</h3>
          {(failCount > 0) && (<h3 style={{ textAlign: "center", color: "#858585" }}>{failCount} sites failed to {action}</h3>)}
        </div>
        <br></br>
        <br></br>
      </div>
    )
  }

  const showLoadingModal = () => {
    setModalTitle('Please wait...')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.ModalIcon} src={loading}>
        </img>
        <br></br>
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>Performing action, please wait...</h3>
        </div>
        <br></br>
        <br></br>
      </div>
    )
    HandleShowModal();
  }

  const HandleMassReset = async () => {
    showLoadingModal();
    const results = await Promise.allSettled(
      checkedSites.map(site =>
        resetSite(apiData, site.uuid, userID, "", dispatch)
          .then(() => ({ uuid: site.uuid, success: true }))
          .catch((error) => ({ uuid: site.uuid, success: false, error }))
      )
    );

    const successes = results.filter(r => r.value?.success).map(r => r.value.uuid);
    const fails = results.filter(r => r.status === 'rejected' || r.value?.success === false).map(r => (r.reason?.uuid || r.value?.uuid));

    ShowActionCompleteModal(successes.length, fails.length, "reset")
  };

  const HandleMassSuspend = async () => {
    showLoadingModal();
    const allSuspended = checkedSites.every(site => site.status === "suspended");
    const action = allSuspended ? "available" : "suspended";
    const uuids = checkedSites.map(site => site.uuid)
    const results = await Promise.allSettled(
      checkedSites.map(site =>
        suspendDevice(apiData, action, site.id, dispatch)
          .then(() => ({ uuid: site.uuid, success: true }))
          .catch((error) => ({ uuid: site.uuid, success: false, error }))
      ),

      setSiteDevices((prevSiteDevices) => {
        const uuidSet = new Set(uuids);
        return prevSiteDevices.map((device) =>
          uuidSet.has(device.uuid)
            ? { ...device, status: action }
            : device
        );
      })
    );

    const successes = results.filter(r => r.value?.success).map(r => r.value.uuid);
    const fails = results.filter(r => r.status === 'rejected' || r.value?.success === false).map(r => (r.reason?.uuid || r.value?.uuid));

    const actionCompleted = action == "suspended" ? "suspended" : "unsuspended"
    ShowActionCompleteModal(successes.length, fails.length, actionCompleted)
  }

  const HandleMassDeactivate = async () => {
    showLoadingModal();
    const allActive = checkedSites.every(site => site.active == 1);
    let action = 1
    if (allActive){
      action = 0
    }

    const popupText = action == 1 ? "activated" : "deactivated"
    const results = await Promise.allSettled(
      checkedSites.map(async site => {
        let body = {
          uuid: site.uuid,
          active: action
        };
  
        try {
          await setSiteActive(apiData, body, dispatch);
          return ({ uuid: site.uuid, success: true });
        } catch (error) {
          return ({ uuid: site.uuid, success: false, error });
        }
      })
    );
  
    console.log(results);
    const successes = results.filter(r => r.value?.success).map(r => r.value.uuid);
    const fails = results.filter(r => r.status === 'rejected' || r.value?.success === false).map(r => (r.reason?.uuid || r.value?.uuid));
    
    setSiteDevices(prevSiteDevices =>
      prevSiteDevices.map(device =>
        successes.includes(device.uuid)
          ? { ...device, active: action }
          : device
      )
    );

    ShowActionCompleteModal(successes.length, fails.length, popupText)
  }

  const HandleSingleDeactivateSite = async (row) => {
    let body = {
      uuid: row.uuid,
      active: row.active == 1 ? 0 : 1
    };

    
    const response = await setSiteActive(apiData, body, dispatch);
    if (response.success){
      setSiteDevices((prevSiteDevices) =>
        prevSiteDevices.map((device) =>
            device.uuid === body.uuid ? { ...device, active: body.active } : device
        )
      );
    }
  
  }

  const HandleMassClearLogs = async () => {
    showLoadingModal();
    const results = await Promise.allSettled(
      checkedSites.map(site =>
        clearDeviceLogs(apiData, site.uuid, userID, dispatch)
          .then(() => ({ uuid: site.uuid, success: true }))
          .catch((error) => ({ uuid: site.uuid, success: false, error }))
      )
    );

    const successes = results.filter(r => r.value?.success).map(r => r.value.uuid);
    const fails = results.filter(r => r.status === 'rejected' || r.value?.success === false).map(r => (r.reason?.uuid || r.value?.uuid));

    ShowActionCompleteModal(successes.length, fails.length, "cleared logs for")
  }

  const HandleMassAddToGroup = async () => {
    console.log("called")
    showLoadingModal();
    //const group = groups.find(group => group.name === dataManager.getItem('selectedGroup'))
    // if (!group) {
    //   console.error("Selected group not found");
    //   return;
    // }

    const uuids = checkedSites.map(site => site.uuid)
    const body = {
      groupID: selectedGroup.id,
      groupName: selectedGroup.name,
      groupDevices: uuids
    }
    console.log(uuids)
    console.log(body)

    const response = await addSitesToGroup(apiData, body, dispatch)
    if (response.success) {
      setAddToGroupVisible(false)
      setSiteDevices((prevSiteDevices) => {
        const uuidSet = new Set(uuids);

        return prevSiteDevices.map((device) =>
          uuidSet.has(device.uuid)
            ? { ...device, name: selectedGroup.name }
            : device
        );
      });



      ShowActionCompleteModal(uuids.length, 0, "added")
    }
  }

  const HandleMassAddUser = () => {

  }

  useEffect(() => {
    switch (selectedMassAction) {
      case "Reset sites": {
        setModalTitle("Are you sure?")
        setModalComponent(
          <div>
            <div style={{ textAlign: "center" }}>
              <h2>Are you sure you want to reset {checkedSites.length} sites?</h2>
            </div>
            <p style={{ textAlign: "center" }}>This will revert all settings & customisations to factory default.</p>
            <p style={{ textAlign: "center" }}>This action cannot be undone!</p>

            <br></br>
            <ChangeGroup
              apiData={apiData}
              DeviceUUID={""}
              companyName={""}
              NotificationTitle={""}
              label={"To change group, please select a new group below"}
              dropDownOptions={groups.map(group => group.name).sort((a, b) => a.localeCompare(b))}
              HandleCloseModal={HandleCloseModal}
              update={update}
              setUpdate={setUpdate}
              SiteDevices={SiteDevices}
              setSiteDevices={setSiteDevices}
            />
            <br></br>
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px"
            }}>
              <Button1 onClick={HandleCloseModal}>No, cancel</Button1>
              <Button1 onClick={HandleMassReset}>Yes, I'm sure</Button1>
            </div>
          </div>
        )
        HandleShowModal();
        break;
      }
      case "Suspend/Unsuspend sites": {
        const allSuspended = checkedSites.every(site => site.status === "suspended");
        const action = allSuspended ? "unsuspend" : "suspend";
        setModalTitle("Are you sure?")
        setModalComponent(
          <div>
            <div style={{ textAlign: "center" }}>
              <h2>Are you sure you want to {action} {checkedSites.length} sites?</h2>
            </div>
            <br></br>
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px"
            }}>
              <Button1 onClick={HandleCloseModal}>No, cancel</Button1>
              <Button1 onClick={HandleMassSuspend}>Yes, I'm sure</Button1>
            </div>
          </div>
        )
        HandleShowModal();
        break;
      }
      case "Clear event logs": {
        setModalTitle("Are you sure?")
        setModalComponent(
          <div>
            <div style={{ textAlign: "center" }}>
              <h2>Are you sure you want to delete {checkedSites.length} sites event logs?</h2>
            </div>
            <br></br>
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px"
            }}>
              <Button1 onClick={HandleCloseModal}>No, cancel</Button1>
              <Button1 onClick={HandleMassClearLogs}>Yes, I'm sure</Button1>
            </div>
          </div>
        )
        HandleShowModal();
        break;
      }
      case "Add sites to group": {
        setIsMassAction(true)
       
        setAddToGroupVisible(true)
        
        break;
      }
      case "Add users": {

        // setModalTitle(`Add users to ${checkedSites.length} sites`)
        showAddUserModal();

        break;
      }
      case "Switch active status" : {
        const allInactive = checkedSites.every(site => site.active === 0);
        const action = allInactive ?  "activate ": "deactivate";
        setModalTitle("Are you sure?")
        setModalComponent(
          <div>
            <div style={{ textAlign: "center" }}>
              <h2>Are you sure you want to {action} {checkedSites.length} sites?</h2>
            </div>
            <br></br>
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px"
            }}>
              <Button1 onClick={HandleCloseModal}>No, cancel</Button1>
              <Button1 onClick={() => HandleMassDeactivate()}>Yes, I'm sure</Button1>
            </div>
          </div>
        )
        HandleShowModal();
        break;
      }
      default: {
        //do nothing?
      }
    }

  }, [selectedMassAction])

  const handleNextClick = () => {
    isMassAction ? AddSiteToGroup() : HandleMassAddToGroup();
  };

  useEffect(() => {
    if (success) {
      successModal(message, false)
      setSuccess(false)
    }

    if (failure) {
      errorModal(message, false)
      setFail(false)
    }
  }, [success, failure])

  const showCompleteAddModal = () => {
    setModalTitle("Please wait…");
    setIsCompleteModalOpen(true);
    setIsAddUserModalOpen(false)
  };

  const hideCompleteAddModal = () => {
    if (isCompleteModalOpen) {
      setIsCompleteModalOpen(false)
      setSelectedMassAction("")
      setModalMessageSuccess("")
      setModalMessageFail("")
    }
  }

  const showAddUserModal = () => {
    setModalTitle("Add users");
    setIsAddUserModalOpen(true)
  };



  const massActionOptions = [
    "Add users",
    "Reset sites",
    "Switch active status",
    "Suspend/Unsuspend sites",
    "Clear event logs",
    "Add sites to group"
  ]

  return (
    <>
      <Dialog
          header="Add to group"
          visible={addToGroupVisible}
          style={{ width: "40vw" }}
          onHide={() => setAddToGroupVisible(false)}
          >
          <div>
          <p>Choose new group from the dropdown below</p>
              <Dropdown 
              value={selectedGroup} 
              onChange={(e) => setSelectedGroup(e.value)} 
              options={groups} 
              optionLabel="name"
              showClear
              filter
              placeholder="Select a group" 
              className="w-full md:w-14rem" />
          </div>

          <br></br>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button label="Next" severity="success" disabled={!selectedGroup} onClick={() => isMassAction ? HandleMassAddToGroup() : AddSiteToGroup()} />
          </div>
        </Dialog>

        <Dialog
            header="Success"
            visible={successVisible}
            style={{ width: "40vw" }}
            onHide={() => setSuccessVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff"}}>Group created successfully!.</h3>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 250, height: 250, margin: "0px" }}
                />

                <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setSuccessVisible(false)}/>
            </div>
        </Dialog>


      <div className="card flex justify-content-center">
        { isCompleteModalOpen && (<Dialog header="Adding users..." visible={isCompleteModalOpen} style={{ width: '50vw' }} onHide={() => { if (!isCompleteModalOpen) return; setIsCompleteModalOpen(false); }}>
          <div className="flex flex-col items-center justify-center">
            {/* white-space:pre-line shows each “\n” on its own line */}
            <h3 style={{ whiteSpace: "pre-line", color: "#858585", textAlign: "center" }}>
              {modalMessageSuccess || ""}
            </h3>

            <h3 style={{ whiteSpace: "pre-line", color: "#858585", textAlign: "center" }}>
              {modalMessageFail || ""}
            </h3>

            <br />
            <Button1 style={{ width: "100%" }} onClick={hideCompleteAddModal}>
              Close
            </Button1>
          </div>
        </Dialog>)}
      </div>

      <div className="card flex justify-content-center">
        {isAddUserModalOpen && (<Dialog header={`Add users to ${checkedSites.length} site(s)`} visible={isAddUserModalOpen} style={{ width: '50vw' }} onHide={() => { if (!isAddUserModalOpen) return; setIsAddUserModalOpen(false); }}>
          <MassAddUserForm
            apiData={apiData}
            sites={checkedSites}
            userID={userID}
            HandleCloseModal={HandleCloseModal}
            companyName={company}
            showAddingUsersModal={showCompleteAddModal}
            setModalMessageSuccess={setModalMessageSuccess}
            setModalMessageFail={setModalMessageFail} />
        </Dialog>)}
      </div>

      <Modal ref={ModalDialog} title={modalTitle} modalName={"Site View"} HandleShowModal={HandleShowModal}>
        {modalComponent}
      </Modal>

      <div className={`${classes.table} ${classes.center} `}>
        <ListCard secondaryClassName={classes["Card-container"]}>
          <div className={classes["tableCardLayoutUI-wrapper"]} style={{ padding: "0px 10px 0px 10px" }}>
            <Suspense fallback={
              <div className={classes["loadingSpinner-container"]}>
                <Oval stroke="var(--Primary-Color)" height={200} width={100} speed={1.5} />
              </div>}>

              {(showMassSettings && !addAccessMode && !editUserAccess && !groupMode && !sitesForGroupMode) &&(
                <div style={{ marginTop: "3px", marginBottom: "5px" }}>
                  <Dropdown value={selectedMassAction} onChange={(e) => setSelectedMassAction(e.value)} options={massActionOptions}
                    placeholder="Select an action" className="w-full md:w-14rem" />
                </div>
              )}

              <Await resolve={SiteDevices}>
                {(loadedtableData) =>
                  <div style={{ width: "auto", minWidth: "1000px", height: "100%", minHeight: "500px" }} >
                    {(groupMode || addAccessMode || editUserAccess || sitesForGroupMode) && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: "0px", marginBottom: "0px" }}>
                          <input
                            type="checkbox"
                            id={`checkbox`}
                            className={classes["circular-checkbox"]}
                            onChange={() => HandleSelectAll()}
                          />
                          <label
                            style={{
                              marginRight: "10px",
                              marginLeft: "10px",
                              display: 'flex',
                              alignItems: 'center'
                            }}
                            htmlFor={`checkbox`}
                            className={classes['custom-checkbox']}
                          />
                          <span>Select all</span>
                        </div>
                      </div>
                    )}

                    <br></br>
                    <BasicTable
                      data={loadedtableData}
                      columns={tablecolumns}
                      allColumns={tablecolumns}
                      filtering={filtering}
                      rowClick={false}
                      ShowPagination={false}
                      PageSize={5000}
                      paginationOptions={[25, 50, 100]}
                      showFilterButton={false}
                      isSortable={isSortable}
                    />
                  </div>
                }
              </Await>
            </Suspense>
            <br></br>
            <br></br>
            {!hideControls && (
              <GridPaginationControls
                pageIndex={pageFetchedIndex}
                nextPage={HandleNextPage}
                previousPage={HandlePreviousPage}
                setPageIndex={HandleSetPageIndex}
                pageCount={totalPages}
                setPageSize={HandlePageSize}
                PageSize={pageSize}
                totalDevices={totalDevices}
                setTotalDevices={setTotalDevices}
                hidePageSize={offlineOnly}
              />
            )}
          </div>
        </ListCard>
      </div>
    </>
  )
}

export default DevicesList;